import { styled } from "@mui/material";

export const Value = styled("span")(({ theme }) => ({
  fontFamily: theme.typography.fontFamilyMono,
  fontWeight: theme.typography.fontWeightMedium,
}));

export const Units = styled("span")(({ theme }) => ({
  color: theme.palette.grey[600],
  fontFamily: theme.typography.fontFamilyMono,
  fontSize: theme.spacing(1.25),
  fontWeight: theme.typography.fontWeightRegular,
}));
